@switch (type()) {
  @case (1) {
    <div class="tw-relative tw-flex tw-items-center tw-justify-center">
      <div
        class="{{
          class()
        }} tw-animate-dot-grow tw-mx-[0.1875rem] tw-flex tw-scale-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#dc3545]"
      ></div>
      <div
        class="{{
          class()
        }} tw-animate-dot-grow tw-animation-delay-300 tw-mx-[0.1875rem] tw-flex tw-scale-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#fa8b14]"
      ></div>
      <div
        class="{{
          class()
        }} tw-animate-dot-grow tw-animation-delay-[600ms] tw-mx-[0.1875rem] tw-flex tw-scale-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#28a745]"
      ></div>
      <div
        class="{{
          class()
        }} tw-animate-dot-grow tw-animation-delay-[900ms] tw-mx-[0.1875rem] tw-flex tw-scale-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#17a2b8]"
      ></div>
    </div>
  }

  @case (2) {
    <div class="tw-text-white">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-space-x-2 tw-bg-transparent"
      >
        <div
          class="tw-size-2 tw-min-h-2 tw-min-w-2 tw-animate-bounce tw-rounded-full tw-bg-current tw-animation-delay-300"
        ></div>
        <div
          class="tw-size-2 tw-min-h-2 tw-min-w-2 tw-animate-bounce tw-rounded-full tw-bg-current tw-animation-delay-150"
        ></div>
        <div
          class="tw-size-2 tw-min-h-2 tw-min-w-2 tw-animate-bounce tw-rounded-full tw-bg-current"
        ></div>
      </div>
    </div>
  }
}
